import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

import styles from './Header.module.css';
import imageLogoNew from "../../../assets/images/BSPLogoTranSmall.png"; // Ensure this path is correct

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation(); // Gets current URL path

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Helper to check if link is active
  const isActive = (path) => {
    return location.pathname === path ? styles.activeLink : '';
  };

  return (
    <header className={styles.headerWrapper}>
      <div className={styles.container}>
        
        {/* LOGO */}
        <Link to="/" className={styles.logo}>
          <img
            src={imageLogoNew}
            alt="Build Start Logo"
            style={{ height: '40px', marginRight: '10px' }} 
          />
        </Link>

        {/* NAVIGATION LINKS */}
        <nav className={`${styles.nav} ${isMenuOpen ? styles.navMobile : ''}`}>
          <ul className={styles.navLinks}>
            {/* Mobile Close Icon */}
            <li className={styles.closeIcon} onClick={toggleMenu}>
              <FaTimes />
            </li>

            {/* Links with Active State Logic */}
            <li className={isActive('/')}>
                <Link to="/" onClick={() => setIsMenuOpen(false)}>Home Owner</Link>
            </li>
            <li className={isActive('/business-landing')}>
                <Link to="/business-landing" onClick={() => setIsMenuOpen(false)}>For Building Professionals</Link>
            </li>
            <li className={isActive('/for-developers')}>
                <Link to="/for-developers" onClick={() => setIsMenuOpen(false)}>For Renovators / Developers</Link>
            </li>
            <li className={isActive('/resources-hub')}>
                <Link to="/resources-hub" onClick={() => setIsMenuOpen(false)}>Resource Hub</Link>
            </li>
            <li className={isActive('/contact-support')}>
                <Link to="/contact-support" onClick={() => setIsMenuOpen(false)}>Support</Link>
            </li>

            {/* Mobile-Only Auth Buttons */}
            <li className={styles.mobileAuth}>
              <Link to="/login" className={styles.btnLogin} onClick={toggleMenu}>Login</Link>
            </li>
            <li className={styles.mobileAuth}>
              <Link to="/select-role" className={styles.btnRegister} onClick={toggleMenu}>Register</Link>
            </li>
          </ul>
        </nav>

        {/* DESKTOP RIGHT BUTTONS */}
        <div className={styles.headerRight}>
          <Link to="/login" className={styles.btnLogin}>Login</Link>
          <Link to="/select-role" className={styles.btnRegister}>Register</Link>
        </div>

        {/* MOBILE BURGER ICON */}
        <div className={styles.menuIcon} onClick={toggleMenu}>
          <FaBars />
        </div>
      </div>
    </header>
  );
};

export default Header;